import type { ComponentProps } from 'react';

export const CloseIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M6 17.9994L18 5.99939" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 17.9994L6 5.99939" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};
